import contactus from 'Components/modals/ContactUs/reducer';
import installApp from 'Components/modals/InstallApp/reducer';
import invite from 'Components/NavBar/Invite/reducer';
import pushNotification from 'Components/NotificationPermissionModal/reducer';
import terms from 'Components/TermsAndConditions/reducer';
import { combineReducers } from 'redux';

import survey from '../../components/modals/Survey/reducer';

export default combineReducers({
  terms,
  invite,
  contactus,
  installApp,
  pushNotification,
  survey,
});
